import { useState } from "react";
import { Grid, Typography, TextField, Button, Alert } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../../assets/kazhavda-logo.png";
import "./Login.css";

const API = process.env.REACT_APP_API_BASE;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email) {
      setStatus({ type: "error", message: "Внесете е-мејл адреса." });
      return;
    }

    try {
      setIsSubmitting(true);
      setStatus({ type: "", message: "" });

      const endpoint = new URL(`${API}/forgot-password`);
      endpoint.searchParams.set("email", email);

      const response = await fetch(endpoint.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData?.message || "Неуспешно испраќање на барањето."
        );
      }

      setStatus({
        type: "success",
        message:
          "Доколку постои профил со овој е-мејл, испратена е порака за ресетирање.",
      });
    } catch (error) {
      setStatus({
        type: "error",
        message: error.message || "Настана грешка. Обидете се повторно.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid
        item
        size={{ xs: 10, md: 8, lg: 6, xl: 4 }}
        className="form-container"
      >
        <form onSubmit={handleSubmit}>
          <Grid container direction="column" spacing={2}>
            <Grid item className="form-container-logo">
              <img src={logo} alt="Kazhav Da Logo" className="form-logo" />
            </Grid>
            <Grid item>
              <Typography variant="h5" className="form-title">
                Заборавена лозинка
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="textSecondary">
                Внесете е-мејл адреса за да ви испратиме линк за ресетирање на
                лозинката.
              </Typography>
            </Grid>
            {status.message && (
              <Grid item>
                <Alert severity={status.type === "success" ? "success" : "error"}>
                  {status.message}
                </Alert>
              </Grid>
            )}
            <Grid item>
              <TextField
                label="Е-мејл адреса"
                type="email"
                variant="outlined"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-text-field"
                required
              />
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                className="button-login"
                fullWidth
                disabled={isSubmitting}
              >
                {isSubmitting ? "Се испраќа..." : "Испрати линк"}
              </Button>
            </Grid>
            <Grid item>
              <Typography variant="body2" className="form-container-link">
                <Link to="/login" className="custom-link">
                  Назад кон најава
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
